import { render, staticRenderFns } from "./ValidationTemplate.vue?vue&type=template&id=8fa3f7a8&"
import script from "./ValidationTemplate.vue?vue&type=script&lang=js&"
export * from "./ValidationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ValidationTemplate.vue?vue&type=style&index=0&id=8fa3f7a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports